import React, { Component } from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import styles from "./style.module.scss";
import { RouteComponentProps } from "react-router";
import { FormComponentProps } from "antd/es/form";
import { Form, Icon, Button, Select, Input, Modal } from "antd";
import { QUERY } from "../../utilities/network";
import { GET_GROUPS, GroupType } from "../groupList";
import CONST from "../../utilities/constant";
const dayjs = require("dayjs");
import { Button as MuiButton } from "@material-ui/core";

const FormItemLayout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 20,
  },
};
const FormItemLayoutWithOutLabel = {
  wrapperCol: {
    span: 20,
    offset: 4,
  },
};

const MONTH_START_DATE = dayjs("2020-01-01");
const WHOLE_ORGANIZATION_GROUP = -1;
const LANGUAGE_OPTIONS = [
  { label: "English", value: "en" },
  { label: "Swedish", value: "sv" },
];

@observer
class MonthlyReportPage extends Component<FormComponentProps & RouteComponentProps<{}>> {
  monthOptions: Array<{ startDate: any; endDate: any; label: string }> = [];
  @observable receiverKeys: Array<number> = [+new Date()];
  @observable submitting = false;
  @observable groups: Array<GroupType> = [];

  async componentDidMount() {
    const diffMonths = dayjs().diff(MONTH_START_DATE, "month");

    this.monthOptions = new Array(diffMonths).fill("").map((_, i) => {
      const startDate = MONTH_START_DATE.add(i, "month");
      const endDate = MONTH_START_DATE.add(i + 1, "month").add(-1, "second");
      const label = startDate.format("MMMM YYYY");

      return {
        startDate,
        endDate,
        label,
      };
    });

    await this._fetchGroups();
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <article>Monthly report</article>
        <div className={styles.content}>
          <Form className={styles.form}>
            {this._renderMonthSelect()}
            {this._renderGroupSelect()}
            {this._renderLanguageSelect()}

            {this.receiverKeys.map((key, index) => {
              const removeIconCls =
                this.receiverKeys.length === 1 ? styles.email_remove_icon_disable : undefined;
              return (
                <Form.Item
                  {...(index === 0 ? FormItemLayout : FormItemLayoutWithOutLabel)}
                  label={index === 0 && "Receivers"}
                  required={true}
                  key={key}
                >
                  {getFieldDecorator(`receiverKeys[${key}]`, {
                    rules: [
                      {
                        type: "email",
                        message: "The input is not valid E-mail!",
                      },
                      {
                        required: true,
                        message: "Please input the receiver E-mail!",
                      },
                    ],
                  })(<Input className={styles.email_item} placeholder="E-mail" />)}
                  <Icon
                    className={removeIconCls}
                    type="minus-circle-o"
                    onClick={() => this._removeReceiverKey(key)}
                  />
                </Form.Item>
              );
            })}

            <Form.Item {...FormItemLayoutWithOutLabel}>
              <Button type="dashed" onClick={this._addReceiverKey} style={{ width: "100%" }}>
                <Icon type="plus" />
                Add Receiver
              </Button>
            </Form.Item>

            <Form.Item {...FormItemLayoutWithOutLabel}>
              <MuiButton
                color="primary"
                variant="contained"
                onClick={this._onSubmit}
                disabled={this.submitting}
              >
                Send
              </MuiButton>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }

  _renderMonthSelect = () => {
    return (
      <Form.Item {...FormItemLayout} label="Month" required={true}>
        {this.props.form.getFieldDecorator("month", {
          rules: [
            {
              required: true,
              message: `Please choose a month.`,
            },
          ],
        })(
          <Select className={styles.group_title} placeholder="Which month's report?">
            {this.monthOptions.map((month) => (
              <Select.Option value={month.label} key={month.label}>
                {month.label}
              </Select.Option>
            ))}
          </Select>,
        )}
      </Form.Item>
    );
  };

  _renderGroupSelect = () => {
    return (
      <Form.Item {...FormItemLayout} label="Group" required={true}>
        {this.props.form.getFieldDecorator("groupId", {
          rules: [
            {
              required: true,
              message: `Please choose a group.`,
            },
          ],
        })(
          <Select className={styles.group_title} placeholder="Which group's report?">
            {this.groups.map((group) => (
              <Select.Option value={group.group_id} key={group.group_id}>
                {group.name}
              </Select.Option>
            ))}
          </Select>,
        )}
      </Form.Item>
    );
  };

  _renderLanguageSelect = () => {
    return (
      <Form.Item {...FormItemLayout} label="Language" required={true}>
        {this.props.form.getFieldDecorator("language", {
          rules: [
            {
              required: true,
              message: `Please choose a month.`,
            },
          ],
        })(
          <Select className={styles.group_title} placeholder="In which language?">
            {LANGUAGE_OPTIONS.map((e) => (
              <Select.Option value={e.value} key={e.value}>
                {e.label}
              </Select.Option>
            ))}
          </Select>,
        )}
      </Form.Item>
    );
  };

  _addReceiverKey = () => {
    this.receiverKeys.push(+new Date());
  };

  _removeReceiverKey = (removeKey: number) => {
    if (this.receiverKeys.length > 1) {
      this.receiverKeys = this.receiverKeys.filter((e) => e !== removeKey);
    }
  };

  _fetchGroups = async () => {
    this.groups = [
      // @ts-ignore
      { group_id: WHOLE_ORGANIZATION_GROUP, name: "Total company" },
      ...(await QUERY<{ groups: Array<GroupType> }>(GET_GROUPS)).groups.filter(
        (e) => e.group_id !== CONST.B2C_GROUP_ID,
      ),
    ];
  };

  _onSubmit = () => {
    this.props.form.validateFields(async (error, values) => {
      if (!error) {
        try {
          const monthOption = this.monthOptions.find((e) => e.label === values.month) as any;
          const monthOptionIndex = this.monthOptions.findIndex(
            (month) => month.label === values.month,
          );
          const preMonthOption = this.monthOptions[monthOptionIndex - 1];

          const wholeGroupIds = this.groups
            .map((e) => e.group_id)
            .filter((id) => id !== WHOLE_ORGANIZATION_GROUP);
          const groupIds =
            values.groupId !== WHOLE_ORGANIZATION_GROUP ? [values.groupId] : wholeGroupIds;

          const param = {
            receivers: Object.values(values.receiverKeys),
            groupIds,
            startDate: monthOption.startDate,
            endDate: monthOption.endDate,
            previousStartDate: preMonthOption.startDate,
            previousEndDate: preMonthOption.endDate,
            language: values.language,
          };

          this.submitting = true;
          await QUERY(MONTHLY_REPORT, param);

          Modal.success({
            title: "The monthly report has been sent to your mailbox.",
            okText: "Great",
          });
        } catch (e) {
          Modal.error({
            title: "Failed to get monthly report.",
            content: e.message,
            okText: "Try again later",
          });
        } finally {
          this.submitting = false;
        }
      }
    });
  };
}

export default Form.create()(MonthlyReportPage);

const MONTHLY_REPORT = `
query(
  $receivers: [EmailAddress!]!
  $startDate: DateTime!
  $endDate: DateTime!
  $previousStartDate: DateTime!
  $previousEndDate: DateTime!
  $groupIds: [Int!]!
  $language: ReportLanguage!
) {
  sendReportEmail(
    receivers: $receivers
    startDate: $startDate
    endDate: $endDate
    groupIds: $groupIds
    language: $language
    previousStartDate: $previousStartDate
    previousEndDate: $previousEndDate
  )
}`;
